// @flow
import React from 'react';

import CategoryIcon from './CategoryIcon';
import Text from './Typography';


type Props = {
  name: string,
  types: []
}

const ProviderHeader = ({ name, types }: Props) => (
  <div className='providers__card-header'>
    <CategoryIcon
      name={name}
      className='providers__card-category-icon'
      type={types && types[0] && types[0].type}
    />
    <Text h2 bold className='providers__card-title'>{name}</Text>
  </div>
);

export default ProviderHeader;


// WEBPACK FOOTER //
// ./src/components/shared/ProviderHeader.js